var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"sidebarnav"}},_vm._l((_vm.items),function(nav,key){return _c(_vm.resolveNavComp(nav),{key:key,tag:"component",attrs:{"item":nav}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }